<template>
    <div class="publication__cards  d-flex">
        <div class="publication__card d-flex" v-for="(_item, _idx) in initial">

            <div class="publication__card-left">
                <div class="publication__card-header  d-flex">
                    <img :src="_item.icon" class="publication__card-icon" alt="" v-if="_item.icon">
                    <h3 class="publication__card-title" v-text="_item.title"></h3>
                </div>

                <div class="publication__card-description" v-text="_item.description" ></div>
            </div>
            <div class="publication__card-right d-flex">

              <a :href="_item.link" class="btn publication__btn" v-if="_item.link" @click="setFacility( _item.key )">
                  Выбрать
              </a>

            </div>

        </div>
    </div>
</template>

<script>

const createFacility = {
    autoHelp:       {
        key: 'auto_help',
        title: 'Автопомощь',
        icon: '/assets/images/icons/publication-autohelp.svg',
        description: 'Размещение объявлений о возможности помочь перевозкой животного.',
        link: '/publication/facility',
    },
    photoHelp:       {
        key: 'photo_help',
        title: 'Фотопомощь',
        icon: '/assets/images/icons/publication-photo-help.svg',
        description: 'Размещение объявлений о возможности помочь рекламой или проведением фотосессии для животного.',
        link: '/publication/facility',
    },
    giveAway:       {
        key: 'giveaway',
        title: 'Отдам даром',
        icon: '/assets/images/icons/publication-giveaway.svg',
        description: 'Размещение объявлений о возможности отдать корм или другой товар волонтерскому животному.',
        link: '/publication/facility',
    },
    homestay:       {
        key: 'homestay',
        title: 'Передержка',
        icon: '/assets/images/icons/publication-home.svg',
        description: 'Размещение объявлений о возможности взять волонтерское животное на временную передержку',
        link: '/publication/homestay',
    },
}


import StateMixin from "./mixins/StateMixin";


export default {
    name: "PublicationCreateFacilities",
    mixins: [StateMixin],
    data(){
      return{
        selected: null
      }
    },
    computed: {

        initial() { return createFacility },

    },

    methods:{
        setFacility( type ){

            this.SET_PUBLICATION_TYPE(type)

      }
    }

}
</script>

<style scoped>

</style>
